import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { simulateButtonKeyboardBehavior, simulateButtonKeyboardBehaviorOmitSpace } from '../../utils/buttonKeyboardBehavior.esm.js';
import actionChipStyles from './ActionChip.styles.esm.js';

const ActionChip = React__default.forwardRef((_a, ref) => {
    var { text, onClick, className, "aria-label": ariaLabel, inverse = false, href, disabled = false } = _a, props = __rest(_a, ["text", "onClick", "className", "aria-label", "inverse", "href", "disabled"]);
    const { base, wrapper } = actionChipStyles({ inverse, disabled });
    const Component = href ? "a" : "button";
    // Common props for both button and anchor
    const baseProps = Object.assign({ className: base({ class: className }), ref, "aria-label": ariaLabel }, props);
    const interactionProps = !href // Regular button element
        ? {
            /// For button, we can use the disabled attribute directly
            disabled,
            onClick,
            onKeyDown: disabled
                ? undefined
                : simulateButtonKeyboardBehavior(onClick),
        }
        : href && disabled // Disabled anchor (can't use disabled attribute on <a>)
            ? {
                // For disabled anchor, we need to prevent default behavior and set aria-disabled
                role: "link",
                "aria-disabled": true,
                onClick: (e) => e.preventDefault(),
            }
            : {
                // Active anchor element
                // For anchor, we need to handle keyboard behavior manually
                href,
                onKeyDown: simulateButtonKeyboardBehaviorOmitSpace(onClick),
                onClick,
            };
    return (jsx(Component, Object.assign({}, baseProps, interactionProps, { children: jsx("div", { className: wrapper(), children: jsx("span", { children: text }) }) })));
});
ActionChip.displayName = "ActionChip";

export { ActionChip };
